/* eslint-disable @typescript-eslint/no-explicit-any*/
import {
  ONBOARDING_TAX_ID_STATUS,
  ONBOARDING_CELLPHONE_STATUS,
  ONBOARDING_CREATE_ACCOUNT,
  ONBOARDING_REGISTER_DEVICE,
  ONBOARDING_VALIDATE_TOKEN,
  ONBOARDING_GET_ADDRESS,
  ONBOARDING_GET_ADDRESS_ERROR,
  ONBOARDING_CREATE_ADDRESS,
  ONBOARDING_GET_IMAGE_URL,
  ONBOARDING_UPLOAD_DOCUMENT,
  ONBOARDING_SAVE_USER_PHOTO,
  ONBOARDING_CUSTOM_DOCUMENT,
  ONBOARDING_SAVE_POWER_OF_ATTORNEY,
  ONBOARDING_SAVE_USER_DOCUMENT,
  ONBOARDING_ADD_PARTNER,
  ONBOARDING_TERMS_OF_USE,
  ONBOARDING_CREATE_PIN,
  ONBOARDING_EMAIL_STATUS,
  ONBOARDING_LOGIN_STATUS,
  ONBOARDING_SETTINGS,
  ONBOARDING_GET_REPRESENTANT_ADDRESS,
  ONBOARDING_CNAE_DESCRIPTION,
  ONBOARDING_CNAE_CLEAR_STATUS,
  ONBOARDING_SET_BC_PROTEGE_CONSULTING_ID,
  ONBOARDING_CADASTRAL_SITUATION,
  ONBOARDING_SAVE_REPRESENTANT_DOCUMENT,
  ONBOARDING_CLEAN_REPRESENTANT_DOCUMENT,
  ONBOARDING_SAVE_SOCIAL_CONTRACT,
  ONBOARDING_SAVE_COMPANY_STATUTE,
  ONBOARDING_SAVE_DECLARATION_BENEFICIARIES,
  ONBOARDING_SAVE_MINUTES_OF_ELECTION,
  SET_INVITE_RESPONSE,
  SET_ONBOARDING_CAF_INFO,
  GET_CITIES,
  GET_COUNTRIES,
  GET_STATES,
  SET_ONBOARDING_WEBVIEW_URL,
} from '~/actions/actionTypes';

const initialState: reducers.OnboardingReducer = {
  taxIdStatus: null,
  cellPhoneStatus: null,
  cnaeDescription: null,
  loginStatus: null,
  createAccount: null,
  registerDevice: false,
  validateToken: false,
  getAddress: null,
  getAddressError: false,
  getRepresentantAddress: null,
  createAddress: null,
  getImageUrl: null,
  uploadDocument: false,
  saveUserPhoto: null,
  saveUserDocument: null,
  savePowerOfAttorney: null,
  saveSocialContract: null,
  saveMinutesOfElection: null,
  terms: [],
  representantsDocuments: [],
  createPin: null,
  emailStatus: null,
  settings: null,
  addPartners: false,
  createAccountError: null,
  saveDocument: null,
  cadastralSituation: null,
  inviteResponse: null,
  onboardingCAF: null,
  bornCity: null,
  bornState: null,
  bcProtegeConsultingId: null,
  citiesList: null,
  statesList: null,
  countriesList: null,
  webviewUrl: {
    url: null,
  },
};

const onboardingReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case ONBOARDING_TAX_ID_STATUS:
      state = {
        ...state,
        taxIdStatus: action.payload,
      };
      break;

    case ONBOARDING_CELLPHONE_STATUS:
      state = {
        ...state,
        cellPhoneStatus: action.payload,
      };
      break;
    case ONBOARDING_CNAE_DESCRIPTION:
      state = {
        ...state,
        cnaeDescription: action.payload ? action.payload.description : '',
      };
      break;
    case ONBOARDING_CNAE_CLEAR_STATUS:
      state = {
        ...state,
        cnaeDescription: action.payload,
      };
      break;
    case ONBOARDING_SET_BC_PROTEGE_CONSULTING_ID:
      state = {
        ...state,
        bcProtegeConsultingId: action.payload,
      };
      break;
    case ONBOARDING_LOGIN_STATUS:
      state = {
        ...state,
        loginStatus: action.payload,
      };
      break;
    case SET_INVITE_RESPONSE:
      state = {
        ...state,
        inviteResponse: action.payload,
      };
      break;
    case ONBOARDING_EMAIL_STATUS:
      state = {
        ...state,
        emailStatus: action.payload,
      };
      break;

    case ONBOARDING_CREATE_ACCOUNT:
      state = {
        ...state,
        createAccount: action.payload,
      };
      break;

    case ONBOARDING_REGISTER_DEVICE:
      state = {
        ...state,
        registerDevice: action.payload,
      };
      break;

    case ONBOARDING_VALIDATE_TOKEN:
      state = {
        ...state,
        validateToken: action.payload,
      };
      break;

    case ONBOARDING_GET_ADDRESS:
      state = {
        ...state,
        getAddress: action.payload,
      };
      break;

    case ONBOARDING_GET_ADDRESS_ERROR:
      state = {
        ...state,
        getAddressError: action.payload,
      };
      break;

    case ONBOARDING_GET_REPRESENTANT_ADDRESS:
      state = {
        ...state,
        getRepresentantAddress: action.payload,
      };
      break;

    case ONBOARDING_TERMS_OF_USE:
      state = {
        ...state,
        terms: action.payload,
      };
      break;

    case ONBOARDING_CREATE_ADDRESS:
      state = {
        ...state,
        createAddress: action.payload,
      };
      break;

    case ONBOARDING_ADD_PARTNER:
      state = {
        ...state,
        addPartners: action.payload,
      };
      break;

    case ONBOARDING_GET_IMAGE_URL:
      state = {
        ...state,
        getImageUrl: action.payload,
      };
      break;

    case ONBOARDING_UPLOAD_DOCUMENT:
      state = {
        ...state,
        uploadDocument: action.payload,
      };
      break;

    case ONBOARDING_SAVE_USER_PHOTO:
      state = {
        ...state,
        saveUserPhoto: action.payload,
      };
      break;

    case ONBOARDING_CUSTOM_DOCUMENT:
      state = {
        ...state,
        saveDocument: action.payload,
      };
      break;

    case ONBOARDING_CADASTRAL_SITUATION:
      state = {
        ...state,
        cadastralSituation: action.payload,
      };
      break;

    case ONBOARDING_SAVE_POWER_OF_ATTORNEY:
      state = {
        ...state,
        savePowerOfAttorney: action.payload,
      };
      break;

    case ONBOARDING_SAVE_SOCIAL_CONTRACT:
      state = {
        ...state,
        saveSocialContract: action.payload,
      };
      break;

    case ONBOARDING_SAVE_COMPANY_STATUTE:
      state = {
        ...state,
        saveSocialContract: action.payload,
      };
      break;

    case ONBOARDING_SAVE_DECLARATION_BENEFICIARIES:
      state = {
        ...state,
        saveSocialContract: action.payload,
      };
      break;

    case ONBOARDING_SAVE_MINUTES_OF_ELECTION:
      state = {
        ...state,
        saveMinutesOfElection: action.payload,
      };
      break;

    case ONBOARDING_SETTINGS:
      state = {
        ...state,
        settings: action.payload,
      };
      break;

    case ONBOARDING_SAVE_USER_DOCUMENT:
      state = {
        ...state,
        saveUserDocument: action.payload,
      };
      break;

    case ONBOARDING_SAVE_REPRESENTANT_DOCUMENT:
      state = {
        ...state,
        representantsDocuments: state.representantsDocuments?.concat(
          action.payload
        ),
      };
      break;

    case ONBOARDING_CLEAN_REPRESENTANT_DOCUMENT:
      state = {
        ...state,
        representantsDocuments: [],
      };
      break;

    case ONBOARDING_CREATE_PIN:
      state = {
        ...state,
        createPin: action.payload,
      };
      break;

    case SET_ONBOARDING_CAF_INFO:
      state = {
        ...state,
        onboardingCAF: action.payload,
      };
      break;

    case GET_COUNTRIES:
      return {
        ...state,
        countriesList: action.payload,
      };

    case GET_STATES:
      return {
        ...state,
        statesList: action.payload,
      };

    case GET_CITIES:
      return {
        ...state,
        citiesList: action.payload,
      };

    case SET_ONBOARDING_WEBVIEW_URL:
      return {
        ...state,
        webviewUrl: action.payload,
      };

    default:
      return state;
  }

  return state;
};

export default onboardingReducer;
